export const VER_WibMessage = 1

export interface IWibMessage<$ContentType extends {}> {
    version: number
    senderId: string,
    type: string,
    content: $ContentType
    sentAt: number,
    deleted: boolean
}